/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_File_Tree_RemainingInputs */

const es_components_file_tree_remaining = /** @type {(inputs: Components_File_Tree_RemainingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`restante`)
};

const en_components_file_tree_remaining = /** @type {(inputs: Components_File_Tree_RemainingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`remaining`)
};

/**
* | output |
* | --- |
* | "remaining" |
*
* @param {Components_File_Tree_RemainingInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const components_file_tree_remaining = /** @type {((inputs?: Components_File_Tree_RemainingInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_File_Tree_RemainingInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_components_file_tree_remaining(inputs)
	return en_components_file_tree_remaining(inputs)
});
export { components_file_tree_remaining as "components.file_tree.remaining" }